const tenantId = process.env.REACT_APP_ENTRA_TENANT_ID || 'common';
const apiScope = process.env.REACT_APP_ENTRA_API_SCOPE;

// If no API scope is configured fall back to standard MS Graph/OIDC scopes.
// This prevents acquireTokenSilent receiving [undefined] which causes an
// InteractionRequiredAuthError on every call → loginRedirect loop.
const scopes = apiScope ? [apiScope] : ['openid', 'profile', 'User.Read'];

export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_ENTRA_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${tenantId}`,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: 'localStorage',
    // Persist the auth request in a cookie too, so it survives browsers that drop
    // localStorage across the login redirect (the cause of no_token_request_cache_error).
    storeAuthStateInCookie: true,
  },
};

export const loginRequest = { scopes };
export const silentRequest = { scopes };
